import { IDestinationProject } from '../types/IDestinationProject';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { Request } from './Request';

export interface IGetDestinationProjectParams extends IGetItemsParams {
  contentType: string;
  sourceIds?: string[];
}

export interface IGetDestinationProjectsResult {
  projects: IDestinationProject[];
}

export class GetDestinationProjectsRequest
    extends Request<IGetDestinationProjectParams, IGetDestinationProjectsResult> {
  constructor(params: IGetDestinationProjectParams) {
    super('getDestinationProjects', params);
  }
}
